export default {
    state: {
        arrayFilters: {}
    },
    mutations: {
        setArrayFilters(state, filters) {
            state.arrayFilters = filters
        },
        clearArrayFilters(state) {
            state.arrayFilters = {}
        }
    },
    actions: {
        setCurrentArrayFilters({ commit }, filters) {
            commit('setArrayFilters', filters)
        },
        clearFiltersOnCreate({ commit }) {
            commit('clearArrayFilters')
        }
    },
    getters: {
        getCurrentArrayFilters: state => state.arrayFilters
    }
}
